import Model from './../../common/Model';

class Track extends Model {

	static fieldsInternal() {
		return ['title', 'url', 'image'];
	}

}

export default Track;



/** WEBPACK FOOTER **
 ** ./site/sites/all/themes/custom/abr_theme/js/race-schedule/store/Track.js
 **/